module.exports = __webpack_public_path__ + "img/circle1.0a72f6a2.svg";